import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SpecialDaysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SpecialDaysQuery = { __typename?: 'Query', specialDays?: { __typename?: 'SpecialDayList', items: Array<{ __typename?: 'SpecialDay', id: number, day: string, everyYear: boolean, considerAs: Types.Weekday } | null> } | null };


export const SpecialDaysDocument = gql`
    query SpecialDays {
  specialDays {
    items {
      id
      day
      everyYear
      considerAs
    }
  }
}
    `;

/**
 * __useSpecialDaysQuery__
 *
 * To run a query within a React component, call `useSpecialDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialDaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecialDaysQuery(baseOptions?: Apollo.QueryHookOptions<SpecialDaysQuery, SpecialDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialDaysQuery, SpecialDaysQueryVariables>(SpecialDaysDocument, options);
      }
export function useSpecialDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialDaysQuery, SpecialDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialDaysQuery, SpecialDaysQueryVariables>(SpecialDaysDocument, options);
        }
export function useSpecialDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecialDaysQuery, SpecialDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecialDaysQuery, SpecialDaysQueryVariables>(SpecialDaysDocument, options);
        }
export type SpecialDaysQueryHookResult = ReturnType<typeof useSpecialDaysQuery>;
export type SpecialDaysLazyQueryHookResult = ReturnType<typeof useSpecialDaysLazyQuery>;
export type SpecialDaysSuspenseQueryHookResult = ReturnType<typeof useSpecialDaysSuspenseQuery>;
export type SpecialDaysQueryResult = Apollo.QueryResult<SpecialDaysQuery, SpecialDaysQueryVariables>;